import { atom } from 'recoil';
import storage from '../../helpers/storage.js';
import { logger } from '@springtree/eva-sdk-core-logger';
export const storageKey = 'evaEndpointUrl';
// This is one of the core atoms that powers the Context for the root state.
// The other core atom is the current user token.
// When either change the root state is reset by setting a new RecoilRoot key.
// The endpoint and user token are also used for unique request persistence.
//
const evaEndpointUrlState = atom({
    key: 'evaEndpointUrl',
    default: storage.getItem(storageKey) || '',
    effects: [
        ({ setSelf }) => {
            // Set initial value from storage
            //
            setSelf(storage.getItem(storageKey) || '');
            // NOTE: Not updating local storage on change here on purpose
            //       this allows the EvaStateEndpointMonitor to detect an
            //       endpoint change and reset the recoil atoms correctly
            //
            // Listen for updates applied through local storage
            // Not that storage events are only triggered from other tabs/windows
            // If you update the storage in the active window itself there will be no trigger
            //
            if (globalThis.addEventListener) {
                globalThis.addEventListener('storage', (storageEvent) => {
                    if (storageEvent.key === storageKey && storageEvent.newValue !== storageEvent.oldValue) {
                        logger.debug('[STATE:evaEndpointUrlState] Storage event', storageEvent);
                        setSelf(storageEvent.newValue ? storageEvent.newValue : '');
                    }
                });
            }
        },
    ],
});
export default evaEndpointUrlState;
//# sourceMappingURL=eva-endpoint-url-state.js.map